import { Check } from 'lucide-react';

interface SelectionIndicatorProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  indeterminate?: boolean;
  className?: string;
}

export const SelectionIndicator = ({
  checked,
  onChange,
  indeterminate = false,
  className = '',
}: SelectionIndicatorProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(!checked);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <span
      className={`flex items-center justify-center h-3 w-3 rounded border transition-all duration-150 ${
        checked
          ? 'bg-primary border-primary'
          : 'border-muted-foreground/40 opacity-0 group-hover:opacity-100 group-hover:border-muted-foreground/70 hover:!border-primary hover:!bg-primary/10'
      } ${className}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="checkbox"
      tabIndex={0}
      aria-checked={indeterminate ? 'mixed' : checked}
    >
      {checked && (
        <Check className="h-2 w-2 text-primary-foreground" strokeWidth={3} />
      )}
      {indeterminate && !checked && (
        <span className="h-0.5 w-1.5 bg-primary rounded-full" />
      )}
    </span>
  );
};

export default SelectionIndicator;
